import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { toast } from "react-toastify";
import Loading from "./Loading";
import { useMutation } from "@tanstack/react-query";
import { spacesDelete } from "../services/spaces";

const SpacesDelete = ({
  open,
  onClose,
  id,
  onAction,
}: {
  open: boolean;
  onClose: () => void;
  id: string | number;
  onAction: () => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: spacesDelete,
    onSuccess: () => {
      onClose();
      onAction();
      toast.success("Espaço deletado");
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  return (
    <Dialog maxWidth="xs" open={open} onClose={() => onClose()}>
      <Loading loading={isPending} />
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={2} padding={1}>
          <Grid2 size={{ xs: 10, md: 11 }}>
            <Typography variant="h2" fontSize={26} fontWeight={600}>
              Deletar espaço
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 2, md: 1 }}>
            <IconButton onClick={() => onClose()}>
              <IconX style={styles.iconStyle} />
            </IconButton>
          </Grid2>
          <Grid2 size={12}>
            <Typography variant="subtitle1" color="secondary.contrastText">
              Você realmente quer deletar este espaço?
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              sx={{ backgroundColor: "red" }}
              onClick={() => mutate({ id })}
            >
              Deletar espaço
            </Button>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

const styles = {
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
    backgroundColor: "secondary.dark",
  },
  iconStyle: {
    color: "primary.main",
  },
};

export default SpacesDelete;
